module.exports = __webpack_public_path__ + "static/media/Assas-lp-details.b077d943.svg";